import { Page, SparkSavingsIcon, SavingsModal } from '@/components';
import { Flex, Heading } from '@blockanalitica/ui';
import SavingsKpiWithChart from './SavingsKpiWithChart';
import SavingsVaults from './SavingsVaults';
import USDSBackedBreakdown from './USDSBackedBreakdown';
import Banner from './Banner';

export default function SavingsPage() {
  return (
    <Page
      title={
        <Flex alignItems="center" gap="xs">
          <SparkSavingsIcon size="4" />
          <Heading>Savings</Heading>
          <SavingsModal iconSize="2" />
        </Flex>
      }>
      <SavingsKpiWithChart />
      <SavingsVaults />
      <Banner />
      <USDSBackedBreakdown />
    </Page>
  );
}
